import { render } from "./OptionsReviews.vue?vue&type=template&id=2fb5d788"
import script from "./OptionsReviews.vue?vue&type=script&lang=js"
export * from "./OptionsReviews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__